/*
 * File: AnimationContext.jsx
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 4, 2025 at 8:53 AM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 4, 2025 at 8:55 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React, {
	createContext, useReducer, useMemo
} from 'react';
import PropTypes from 'prop-types';


/**
 * Context
 */

export const Context = createContext();


/**
 * Component
 */

const AnimationContext = ({ children }) => {

	// Create reducer
	const reducer = (state, action) => {
		switch (action.type) {
			case 'SET_DESKTOP_REACTION_METRIC_POSITION':
				return {
					...state,
					desktopReactionMetric: action.payload,
				};
			case 'SET_MOBILE_REACTION_METRIC_POSITION':
				return {
					...state,
					mobileReactionMetric: action.payload,
				};
			default:
				return state;
		}
	};

	// Set reducers
	const [contextState, contextDispatch] = useReducer(reducer, {});

	// Create memoized context provider
	const contextProvider = useMemo(() => ({ state: contextState, dispatch: contextDispatch }), [contextState, contextDispatch]);

	// Render component
	return (
		<Context.Provider value={contextProvider}>{children}</Context.Provider>
	);
};


/**
 * Configuration
 */

AnimationContext.displayName = 'AnimationContext';
AnimationContext.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
AnimationContext.defaultProps = {
	children: null
};


/**
 * Exports
 */

export { AnimationContext };
export default Context;
